<template>
  <div class="scenarios">
    <div class="scenes" 
      :class="{'two-item':  (sceneInfo.length === 2 || sceneInfo.length === 4),
      'three-item': (sceneInfo.length === 3 || sceneInfo.length === 6), 
      'one-item':  (sceneInfo.length === 1)}">
      <div class="scene-item"
        v-for="(item, index) in sceneInfo" :key="index"
        :style="{backgroundImage: 'url('+item.imgUrl+')'}"
        :class="{'reheght-item': reHeight}">
        <div class="blue-bg"></div>
        <div class="scene-title" :class="{'no-bg-color' : item.noBg}">{{item.title}}</div>
        <div class="scene-info" :class="{'center-info': item.center}">{{item.content}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'scenarios',
  props: ['sceneInfo', 'reHeight']
};
</script>

<style lang="less" scoped>
.scenarios{
  width: 1200px;
  margin: 0 auto;
  div{
    box-sizing: border-box;
  }
  .scenes{
    box-shadow: 0 10px 20px rgba(0,0,0,0.05), 0 6px 6px rgba(0,0,0,0.03);
    .scene-item{
      display: inline-block;
      height: 260px;
      position: relative;
      color: #ffffff;
      vertical-align: top;
      .blue-bg{
        background-color: rgba(0,164,255,0.9);
        width: 100%;
        height: 100%;
        display: none;
      }
      &.reheght-item{
        height: 338px;
        .scene-title{
          line-height: 338px;
          background-color: rgba(5, 27, 50, 0.01);
        }
      }
      .scene-title{
        font-size: 22px;
        line-height: 260px;
        text-align: center;
        background-color: rgba(5,27,50,0.4);
        &.no-bg-color{
        background: none;
        }
      }
      .scene-info{
        font-size: 16px;
        line-height: 1.8;
        width: 100%;
        display: none;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        padding: 0 20px;
        text-align: justify;
        &.center-info{
          text-align: center;
        }
      }
      &:hover{
        .blue-bg{
          display: block;
        }
        .scene-info{
          display: block;
        }
        .scene-title{
          display: none;
        }
      }
    }
    &.one-item{
      .scene-item{
        width: 1200px;
        .scene-info{
          text-align: center;
        }
      }
    }
    &.two-item{
      .scene-item{
        width: 600px;
      }
    }
    &.three-item{
      .scene-item{
        width: 400px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/solution/common/ApplicationScene.vue